import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle
} from "react-google-maps";

const CreateParkingMap = (props) => {
  const {
    latitude,
    longitude,
    color,
    onChange
  } = props;

  const onClick = (e) => {
    onChange([{
      key: "latitude",
      value: e.latLng.lat()
    }, {
      key: "longitude",
      value: e.latLng.lng()
    }]);
  };

  return (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{
        lat: 40.15,
        lng: 44.51
      }}
      onClick={onClick}
    >
      {longitude && latitude ?
        <Marker position={{
          lng: longitude,
          lat: latitude
        }}/>
        : null}
      {longitude && latitude ?
        <Circle
          radius={10}
          center={{
            lng: longitude,
            lat: latitude
          }}
          options={{
            strokeColor: color,
            fillColor: color,
            fillOpacity: 0.4,
            strokeWeight: 1,
          }}
          draggable
          onDragEnd={onClick}
        />
        : null}

    </GoogleMap>
  );
};

export default withScriptjs(withGoogleMap(CreateParkingMap));



// WEBPACK FOOTER //
// ./src/views/pages/scooter/parking/create-parking-map.js